import { render, staticRenderFns } from "./FourListLinkagePanel.vue?vue&type=template&id=08644bb0&"
import script from "./FourListLinkagePanel.vue?vue&type=script&lang=js&"
export * from "./FourListLinkagePanel.vue?vue&type=script&lang=js&"
import style0 from "./FourListLinkagePanel.vue?vue&type=style&index=0&id=08644bb0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports